import { Pipe, PipeTransform } from '@angular/core';
import { MatSelect } from '@angular/material/select';

@Pipe({
  name: 'selectPlaceholder',
})
export class SelectPlaceholderPipe implements PipeTransform {
  transform(select: MatSelect): string {
    if (select.value?.length) {
      return select.value[0] + select.value.length > 1 ? '...' : '';
    } else {
      return $localize`Все`;
    }
  }
}
